import { render, staticRenderFns } from "./manage-whitelist.vue?vue&type=template&id=34ea32c2&scoped=true"
import script from "./manage-whitelist.vue?vue&type=script&lang=js"
export * from "./manage-whitelist.vue?vue&type=script&lang=js"
import style0 from "./manage-whitelist.vue?vue&type=style&index=0&id=34ea32c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ea32c2",
  null
  
)

export default component.exports